module.exports = ["home","favorite","article","calendar_today","credit_card","storefront","touch_app","timeline","android","emoji_transportation","photo_camera","image","music_note","brush","local_shipping","volunteer_activism","directions_car","map","local_offer","my_location","local_fire_department","lunch_dining","local_dining","agriculture","fitness_center","sports_esports","flight_takeoff","travel_explore","wifi","cloud"]


//////////////////
// WEBPACK FOOTER
// ./src/vue/resource/icons.json
// module id = TIik
// module chunks = 3